import React, { forwardRef, useCallback } from 'react';
import styled from '@emotion/styled';
import * as Icons from '@polestar/component-warehouse-react/tokens/icons/Icons';
import { css } from '@emotion/react';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import IconButton from '@polestar/component-warehouse-react/components/icon-button/IconButton';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { focusProviderOptions } from '@polestar/component-warehouse-react/contexts/focus';
import useTrackingData from '@polestar/component-warehouse-react/hooks/useTrackingData';
import { DataLayerAction, DataLayerCategory, DataLayerLabel, } from '@polestar/component-warehouse-react/tokens/analytics/Analytics';
import { useNavigationDrawer } from '@polestar/component-warehouse-react/components/navigation-drawer/NavigationDrawerContext';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
const MenuButton = forwardRef(({ 'aria-label': ariaLabel = 'menu', onClick, controlsNavigationDrawer = true, ...props }, ref) => {
    const { openNavigationDrawer, navigationDrawerExpanded, navigationDrawerId } = useNavigationDrawer();
    const { handleNavigationDrawerTrackingData } = useTrackingData(DataLayerCategory.MENU);
    const navigationAria = controlsNavigationDrawer && navigationDrawerId
        ? {
            expanded: navigationDrawerExpanded,
            controls: navigationDrawerId,
        }
        : {};
    const handleOpenNavigationDrawer = useCallback((event) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        handleNavigationDrawerTrackingData(DataLayerLabel.MENU_OPEN, DataLayerAction.MENU_CLICK);
        if (!!controlsNavigationDrawer) {
            openNavigationDrawer();
        }
    }, [controlsNavigationDrawer, openNavigationDrawer, handleNavigationDrawerTrackingData, onClick]);
    return (React.createElement(StyledButton, { ref: ref, icon: Icons.menu, title: ariaLabel, ...props, onClick: handleOpenNavigationDrawer, ...focusProviderOptions({
            spacing: 6,
        }), size: Sizes.large, ...aria({
            label: ariaLabel,
            ...navigationAria,
        }) }));
});
MenuButton.displayName = 'MenuButton';
export default MenuButton;
const StyledButton = styled(IconButton)(({ theme }) => css(css `
    color: ${theme.menuButton.states.enabled.color};
    width: ${Spacings.large};
    height: ${Spacings.large};

    @media (hover: hover) {
      &:hover {
        color: ${theme.menuButton.states.hover.color};
        box-shadow: none;
      }
    }
    &:active {
      color: ${theme.menuButton.states.active.color};
      box-shadow: none;
    }
  `));
